import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { App } from './App'
import './firebase/Analytics'
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://d1b7544da189bd52a5815c1c00f7d2ea@o4510831627599872.ingest.us.sentry.io/4510831629172736",
  environment: import.meta.env.MODE,
  release: __APP_VERSION__
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
